import { FREE_GROUP_KEYS } from 'getting-started-shared-tasks/gettingStartedGroupKeys';
import { ONBOARDING_SALES_FREE } from 'getting-started-shared-tasks/onboardingKeys';
import { ONBOARDING_VIEWS } from 'user-context/onboardingSettings';
import { CRM_SIGNUP, SALES_SIGNUP } from '../constants/signupConstants';
import { EXPERIENCE_NONE_PARAM, SALES_HUB_INTEREST, SALES_REP_ROLE } from '../constants/surveyConstants'; // @ts-expect-error ts-migrate(7016) FIXME: This will be migrated in the next phase

import { HubletUrl } from '../utils/urls';
const salesExperiencesChecks = [{
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/set-up-crm/${portalId}/templates`
    };
  },
  checks: [{
    signupExperimentTreatments: {
      'gosu-0002': 'variant'
    }
  }]
}, {
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/demo-tour/${portalId}/intro?flowId=new-ic`,
      view: ONBOARDING_VIEWS.SALES,
      onboardingKey: ONBOARDING_SALES_FREE,
      groupKey: FREE_GROUP_KEYS.freeSalesView
    };
  },
  checks: [{
    signupType: SALES_SIGNUP,
    survey: {
      crmExperience: EXPERIENCE_NONE_PARAM,
      jobRole: SALES_REP_ROLE
    }
  }]
}, {
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/demo-tour/${portalId}/intro?flowId=new-leader`,
      view: ONBOARDING_VIEWS.SALES,
      onboardingKey: ONBOARDING_SALES_FREE,
      groupKey: FREE_GROUP_KEYS.freeSalesView
    };
  },
  checks: [{
    signupType: SALES_SIGNUP,
    survey: {
      crmExperience: EXPERIENCE_NONE_PARAM
    }
  }]
}, {
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/user-guide/${portalId}`,
      view: ONBOARDING_VIEWS.SALES,
      onboardingKey: ONBOARDING_SALES_FREE,
      groupKey: FREE_GROUP_KEYS.freeSalesView
    };
  },
  checks: [{
    signupType: SALES_SIGNUP
  }]
}, {
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/user-guide/${portalId}`,
      view: ONBOARDING_VIEWS.SALES,
      onboardingKey: ONBOARDING_SALES_FREE,
      groupKey: FREE_GROUP_KEYS.freeSalesView
    };
  },
  checks: [{
    signupType: CRM_SIGNUP,
    survey: {
      hubInterest: SALES_HUB_INTEREST
    }
  }]
}];
export default salesExperiencesChecks;